import { useState } from 'react';
import { navigateByRelationship } from 'Views/Page/Content/Templates';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

export const useNavigateByRelationshipOnClick = (relationship, {
  beforeOnClick,
  overrideOnClick,
  afterSuccessfulOnClick,
  overrideErrorHandler,
  forceLoading,

  forceFocusMode,
}) => {
  const { loadPageContentLink } = usePageContentContext();
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [loading, setLoading] = useState(false);

  const onClick = (async (event) => {
    setLoading(true);
    try {
      if (beforeOnClick) {
        await beforeOnClick(event, relationship);
      }

      if (overrideOnClick) {
        await overrideOnClick(event, relationship);
      } else {
        await navigateByRelationship(
          relationship,
          loadModalCollectionByLink,
          loadPageContentLink,
          clearModalCollection,
          { forceFocusMode },
        );
      }

      if (afterSuccessfulOnClick) {
        await afterSuccessfulOnClick(event, relationship);
      }
    } catch (err) {
      if (overrideErrorHandler) {
        overrideErrorHandler(err);
        return;
      }
      displayErrorMessage(err, err.errors ?? 'Error: Failed to navigate. Please contact product support.');
    } finally {
      setLoading(false);
    }
  });

  return {
    loading: typeof forceLoading === 'boolean' ? forceLoading : loading,
    onClick,
  };
};
